import { Box, Text } from '@mantine/core';
import type { FC } from 'react';
import { Link } from 'react-router';

interface MenuItemProps {
  text: string;
  active?: boolean;
  to: string;
}

export const MenuItem: FC<MenuItemProps> = ({ text, active, to }) => {
  return (
    <Text component={Link} fw={700} pos="relative" px="xs" py="md" size="md" to={to}>
      {text}
      {active ? <Box bg="gray.9" bottom={0} h={2} left={0} pos="absolute" right={0} /> : null}
    </Text>
  );
};
